import Axios from 'axios'

const axios = Axios.create({
  baseURL: 'https://ai.voiss.cc/'
})

export async function getSim (words = []) {
  const res = await axios.post('/sim', {
    words
  })
  const size = Object.keys(res.data).length + 1
  const matrix = new Array(size)
  for (let i = 0; i < size; i++) {
    matrix[i] = new Array(size)
    for (let j = 0; j < size; j++) {
      const a = Math.min(i, j)
      const b = Math.max(i, j)
      if (a === b) {
        matrix[i][j] = 1
      } else {
        matrix[i][j] = res.data[a][b]
      }
    }
  }
  return matrix
}
